<template>
  <MTooltip placement="top">
    <template v-slot:trigger>
      <a href="javascript:;" v-on="$listeners">
        <MIcon name="copy" />
      </a>
    </template>
    {{ $t('duplicate') }}
  </MTooltip>
</template>

<script>
export default {
  name: 'ControlDuplicateButton',
}
</script>
